// extracted by mini-css-extract-plugin
export var anchor = "FaqAccordion-module--anchor--dd84f";
export var chevron = "FaqAccordion-module--chevron--6d573";
export var paragraph = "FaqAccordion-module--paragraph--b5e30";